import { autoUpdate, flip, useFloating } from '@floating-ui/react';
import { Button, ClickAwayListener, makeStyles, MenuItem, MenuList, Typography } from '@material-ui/core';
import { useSelect } from 'downshift';
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const useStyles = makeStyles(() => ({
  button: (props) => ({
    // border: '1px solid #54c6e8',
    backgroundColor: props.backgroundColor !== undefined ? props.backgroundColor : '#54c6e8',
    color: '#fff',
    width: props.width !== undefined ? props.width : 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'initial',
    '&:hover': {
      background: props.backgroundHover !== undefined ? props.backgroundHover : '#1093b9',
    },
  }),
  menuList: {
    backgroundColor: '#eee',
    borderRadius: 5,
    minWidth: 180,
    marginTop: 5,
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    marginLeft: 10,
  },
  menuItem: {
    backgroundColor: '#eee',
    color: '#000',
    textTransform: 'initial',
    '&:hover': {
      background: '#bfbfbf',
    },
  },
}));

const GroupFloatingButton = ({ actions = [], position = 'botton', disabled, label = 'Ações' }) => {
  const [open, setOpen] = useState(false);

  const styles = useStyles({
    backgroundColor: '#5890aa',
    backgroundHover: '#335674',
    width: 196.25,
  });

  const { x, y, refs, strategy } = useFloating({
    placement: position,
    strategy: 'absolute',
    whileElementsMounted: autoUpdate,
    middleware: [flip()],
  });

  const { getToggleButtonProps, getMenuProps } = useSelect({
    actions,
  });

  const handlerOpenCloseMenu = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <Button
        {...getToggleButtonProps({ ref: refs.reference })}
        onClick={handlerOpenCloseMenu}
        className={styles.button}
        disabled={disabled}
      >
        <Typography>{label}</Typography>
        <FaChevronDown style={{ marginLeft: '5px', marginTop: '2px' }} />
      </Button>
      <div {...getMenuProps({ ref: refs.floating })} style={{ position: strategy, top: y ?? '', left: x ?? '' }}>
        {open && (
          <ClickAwayListener onClickAway={handlerOpenCloseMenu}>
            <MenuList className={styles.menuList}>
              {actions.map((option, index) => (
                <MenuItem key={index} onClick={() => option.onClick(handlerOpenCloseMenu)} className={styles.menuItem}>
                  <Typography>{option.label}</Typography>
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
};

export default GroupFloatingButton;
